import { NetworkStatus } from "@apollo/client";
import { useMemo } from "react";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";

import useSpaceliftVcsReposFiltersVariables from "../useSearchSpaceliftVcsReposSuggestions/useFiltersVariables";
import { SEARCH_SPACELIFT_VCS_REPOS } from "./gql";
import useSpaceliftVcsReposStore from "./store";

const useSpaceliftVcsReposList = () => {
  const { cursor, rowsPerPage, requestedPage } = useSpaceliftVcsReposStore();
  const { fullTextSearch, predicates, filterVariablesLoaded, sortOptionFields } =
    useSpaceliftVcsReposFiltersVariables();

  const { data, error, networkStatus, previousData } = usePolledQuery(SEARCH_SPACELIFT_VCS_REPOS, {
    variables: {
      input: {
        fullTextSearch,
        first: rowsPerPage,
        after: cursor,
        orderBy: sortOptionFields,
        predicates,
        requestedPage,
      },
    },
    skip: !filterVariablesLoaded,
    pollingGroup: PollingIntervalGroups.Lists,
  });

  const repos = useMemo(() => {
    return (
      data?.searchSpaceliftVCSes.edges.map((edge) => edge.node) ||
      previousData?.searchSpaceliftVCSes.edges.map((edge) => edge.node) ||
      []
    );
  }, [data, previousData]);

  const initialLoading =
    (repos.length === 0 && networkStatus === NetworkStatus.loading) || !filterVariablesLoaded;
  const isEmpty = !repos.length && !initialLoading && !fullTextSearch && !predicates.length;
  const searchIsEmpty = !repos.length && !!(fullTextSearch || predicates.length > 0);

  return {
    repos,
    error,
    initialLoading,
    isEmpty,
    searchIsEmpty,
    startCursor: data?.searchSpaceliftVCSes?.pageInfo.startCursor,
    endCursor: data?.searchSpaceliftVCSes?.pageInfo.endCursor,
  };
};

export default useSpaceliftVcsReposList;
